'use client';

import { useEffect } from 'react';
import { captureUtms } from '@/app/utils/utmCapture';

export function UtmCapture() {
    useEffect(() => {
        captureUtms();
    }, []);
    return null;
}
